import { Autocomplete, Box, CircularProgress } from "@mui/material"
import { CenteredBox } from "../../components/layouts/OneViewBox"
import CustomDialog from "../../components/layouts/common/CustomDialog"
import CustomInput from "../../components/inputs/CustomInput"
import { memo } from "react"
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { findObjectKeyByValue } from "../../utils/helpers/main"
import { APP_TYPES } from "../../utils/constants/main"
import { titleCase } from "../../utils/helpers/main"


const CreateVersionUi = ({ title, isUpdate, fields, setFields, loading, onSubmit, modalKey }) => {
    console.log("Modal Key: ", modalKey)
    return <>
        <CustomDialog
            id={"version"}
            loading={loading}
            err={fields?.err}
            onSubmit={onSubmit}
            title={`${isUpdate ? "Update" : "Create"} ${title}`}
            closeText="Close"
            confirmText={`${isUpdate ? "Update" : "Create"}`}
        >
            {loading ? <CenteredBox><CircularProgress /></CenteredBox> :
                <>
                    {<CustomInput
                        disabled={loading}
                        value={fields.name}
                        onChange={(e) => setFields({ ...fields, name: e.target.value })}
                        type="text"
                        label="Version Name*"
                    />}
                    {<CustomInput
                        disabled={loading}
                        value={fields.main_version}
                        onChange={(e) => setFields({ ...fields, main_version: e.target.value })}
                        type="number"
                        label="Main Version*"
                    />}

                    {<CustomInput
                        disabled={loading}
                        value={fields.sub_version}
                        onChange={(e) => setFields({ ...fields, sub_version: e.target.value })}
                        type="number"
                        label="Sub Version*"
                    />}

                    {
                        <Autocomplete
                            disableClearable
                            // disabled={isView}
                            value={fields.app_type ? findObjectKeyByValue(fields.app_type, APP_TYPES) : null}

                            onChange={(e, newVal) => {
                                setFields({ ...fields, app_type: newVal ? newVal._id : null })
                            }}
                            options={[...Object.keys(APP_TYPES).map((key) => ({ label: titleCase(key), _id: APP_TYPES[key] }))]}
                            sx={{ width: "100%", display: "flex", "*": { display: "flex", justifyContent: "center" } }}
                            renderInput={(fields) => <CustomInput placeholder="Select Type*" {...fields} label="Select Type*" />}
                        />
                    }

                    <Box>
                        {/* <FileInput
                            multi
                            sx={{ width: "100%" }}
                            onChange={(file, fileArr) => {
                                setFields({ ...fields, url: fileArr });
                            }}
                            defaults={fields.url ?? []}
                            accept=".pdf"
                            title="Company Policy PDF"
                            subTitle="Only pdf files are allowed! less than 1 MB"
                        /> */}

                        <Box mt={3}>

                            <CKEditor
                                config={{
                                    placeholder: "Write Version Description...",
                                    style: { height: "500px", minHeight: "500px" },
                                    toolbar: { items: ['p', 'heading', 'italic', 'bold', 'blockquote', 'link', 'table', 'undo', 'redo', 'numberedList', 'bulletedList'] }

                                }}
                                name="description"
                                id="description"

                                disabled={loading}
                                editor={ClassicEditor}

                                onInit={(editor) => {

                                }}
                                data={fields.description}
                                onReady={(editor) => {

                                    editor.editing.view.change((writer) => {
                                        writer.setStyle(
                                            "height",
                                            "200px",
                                            editor.editing.view.document.getRoot()
                                        );
                                    });
                                }}
                                onChange={(event, editor) => {
                                    const data = editor.getData()
                                    setFields({ ...fields, err: '', description: data })
                                }}
                                onBlur={(event, editor) => { }}
                                onFocus={(event, editor) => { }}
                            />
                        </Box>
                    </Box>

                </>
            }
        </CustomDialog>

    </>
}
export default memo(CreateVersionUi)